module.exports = __webpack_public_path__ + "static/meta-preview-investors-955366205cb37e7d200ce59de0e04a85.jpg";